<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="goBackToList($event)"> </app-breadcrumb>
    <div class="container-fluid">
      <app-owner-overview (profileDetailsEvent)="getUserDetails($event)"></app-owner-overview>
  
      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="card">
          <div class="card-header-line">
          <div class="row">
            <div class="col-xl-6">
                <!-- <span class="badge badge-success strong border-0 m-3">Person information</span> -->
            </div>
            <div class="col-xl-6">
                <a *ngIf="checkUserLocalEdit" class="badge badge-success strong border-0 m-3 float-end c-pointer"   href="javascript:void(0);" (click)="toggleLocakPersonDetails()">                  
                    Edit Local Contact
                </a>
                <!-- <a *ngIf="!ownerLocalContactDetails?.local_first_name && checkUserLocalAdd" class="badge badge-success strong border-0 m-3 float-end c-pointer"   href="javascript:void(0);" (click)="toggleLocakPersonDetails()">
                    Add Local Contact
                </a> -->
          </div>
        </div>
        </div>
        <div class="card-body">
        <div class="row">
            <div class="col-xl-4">
                <div class="card">
                  <!-- <div class="card-header py-3">
                    <h6 class="card-title">Selected Propertie</h6>                    
                  </div> -->
                  <div class="card-body">
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">First Name</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">	{{ownerLocalContactDetails?.local_first_name }} </span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Last Name</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ownerLocalContactDetails?.local_last_name }}</span>
                      </div>
                    </div>                    
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Phone Number</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ownerLocalContactDetails?.local_phone }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Email</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ownerLocalContactDetails?.local_email }}</span>
                      </div>
                    </div>
                                        
                  </div>
                </div>
              </div>
              </div>
        </div>

        </div>
      </div>
    </div>
</div>

<div #addEditLocalContactButton class="offcanvas offcanvas-end customeoff {{ local_person_details ? 'show':''}}" tabindex="-1" id="local_person_details" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Add Person information</h5>
      <button type="button" class="btn-close" aria-label="Close"  (click)="cancel()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="localPersonForm" (ngSubmit)="onSubmit()" autocomplete="off"> 
        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">First Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="user" formControlName="local_first_name">
            <div *ngIf="localPersonForm?.get('local_first_name')?.invalid && localPersonForm?.get('local_first_name')?.touched" class="required">
                First Name is required
          </div>
        </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-1" class="form-label">Last Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="user1" formControlName="local_last_name">
              <div *ngIf="localPersonForm?.get('local_last_name')?.invalid && localPersonForm?.get('local_last_name')?.touched" class="required">
                Last Name is required
            </div>
          </div>          
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-4" class="form-label">Mobile Number<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="9876543210"
              formControlName="local_phone">
            <div *ngIf="localPersonForm?.get('local_phone')?.errors && localPersonForm?.get('local_phone')?.touched"
              class="required">
              Provide valid mobile number
            </div>
          </div>
        <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-3" class="form-label">Email</label>
              <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="abc@aa.com" formControlName="local_email">              
          </div>

      </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="localPersonForm.invalid || loadingService.isLoading()">Save</button>
                  <button class="btn btn-danger lightme-1" type="button" (click)="cancel()">Cancel</button>
              </div>
      </form>
        </div>
    </div>
  </div>		
  @if(local_person_details){
    <div class="offcanvas-backdrop fade show" (click)="toggleLocakPersonDetails()"></div>
  }

